import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, AlertCircle, CheckCircle, Lock } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/admin/forgot-password`, { email });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center py-12 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full"
      >
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-slate-900 mb-4">
            <Lock className="w-10 h-10 text-orange-500" />
          </div>
          <h1 className="font-oswald font-bold text-3xl text-slate-900 mb-2">FORGOT PASSWORD</h1>
          <p className="text-slate-600">Durga Engineering Works</p>
        </div>

        <div className="bg-white p-8 shadow-lg border-l-4 border-orange-500">
          {success ? (
            <div className="text-center py-4">
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h2 className="font-oswald font-bold text-xl text-slate-900 mb-2">EMAIL SENT!</h2>
              <p className="text-slate-600 mb-6">
                If an account with that email exists, a password reset link has been sent. Check your inbox.
              </p>
              <Link
                to="/admin/login"
                className="bg-orange-500 hover:bg-orange-600 text-white font-oswald px-6 py-3 inline-block transition-all"
              >
                BACK TO LOGIN
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <p className="text-slate-600 text-sm">
                Enter your admin email address and we'll send you a link to reset your password.
              </p>

              {error && (
                <div className="bg-red-50 border-l-4 border-red-500 p-4 flex items-start">
                  <AlertCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-red-700">{error}</p>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Email Address *</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full pl-10 pr-4 h-12 bg-slate-50 border border-slate-300 focus:border-orange-500 focus:ring-1 focus:ring-orange-500"
                    placeholder="eng.durga@gmail.com"
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold font-oswald py-3 transition-all disabled:opacity-50"
              >
                {loading ? 'SENDING...' : 'SEND RESET LINK'}
              </button>
            </form>
          )}

          <div className="mt-6 pt-6 border-t border-slate-200 text-center">
            <Link to="/admin/login" className="text-sm text-orange-500 hover:text-orange-600 font-medium">
              ← Back to Login
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;